export const formatAuthResponse = (apiResponse) => {
    return {
        entityId: apiResponse.entity_id,
        entityType: apiResponse.entity_type,
        redirectUrl: apiResponse.redirect_url,
    };
};
